// @ts-nocheck
import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetBuilderInformation = createChainHandler("SetBuilderInformation", chain, props => {
    const { builderInformation } = props.parameter as { builderInformation?: string };

    if (builderInformation) {
        props.cartToUpdate.properties.builderInformation = builderInformation;
    }
});

addToChainAfter(chain, SetCartStatus, SetBuilderInformation);
